import {Link} from 'react-router-dom';
import {ROUTES} from '@/routes/constants';
import {AlertCircle} from '@/ui-kit/icons';
import styles from './not-found.module.scss';

export const NotFoundPage = () => {
  return (
    <div className={styles.layout}>
      <div className={styles.icon}>{<AlertCircle fontSize={90} />}</div>
      <span>Page Not Found</span>
      <div className={styles.back} data-testid="back-link">
        Click&nbsp;
        <Link to={ROUTES.BASE} className={styles.backLink}>
          here
        </Link>
        &nbsp; to back Home
      </div>
    </div>
  );
};
